import {
    GET_KUDOS_MESSAGES,
    GET_KUDOS_SETTINGS,
    GET_KUDOS_CORRECTIONS,
    GET_KUDOS_SUGGESTION_MESSAGES,
    ADD_KUDOS_MESSAGE,
    GET_KUDOS_BYID,
    UPDATE_KUDOS_MESSAGE,
    KU_LOADING,
    KU_LOADINGBYID,
} from "../actions/KudosActions"

const initialState = {
    kudosmessages: [],
    kudosmessage: [],
    kudossettings: [],
    kudoscorrections: [],
    kudossuggestionmessages: [],
    loadingmessages: true,
    loadingmessage: true,
    loadingsettings: true,
    loadingcorrections: true,
    loadingsuggestionmessages: true,
    success: true,
    addKudos: null
};

const MenuReducer = function(state = initialState, action){
    switch (action.type) {
        case KU_LOADING: {
            return {
              ...state,
              loadingmessages: true,
              loadingsettings: true,
              loadingcorrections: true,
              loadingsuggestionmessages: true,
            }
        }
        case KU_LOADINGBYID: {
            return {
              ...state,
              loadingmessage: true,
            }
        }
        case GET_KUDOS_MESSAGES: {
            return {
                ...state,
                kudosmessages: [...action.data],
                loadingmessages: false
            }
        }
        case GET_KUDOS_SETTINGS: {
            return {
                ...state,
                kudossettings: [...action.data],
                loadingsettings: false
            }
        }
        case GET_KUDOS_CORRECTIONS: {
            return {
                ...state,
                kudoscorrections: [...action.data],
                loadingcorrections: false
            }
        }
        case GET_KUDOS_SUGGESTION_MESSAGES: {
            return {
                ...state,
                kudossuggestionmessages: [...action.data],
                loadingsuggestionmessages: false
            }
        }
        case ADD_KUDOS_MESSAGE: {
            return {
                ...state,
                addKudos: action.data,
                success: true,
                loadingmessages: false,
                loadingsettings: false,
                loadingcorrections: false,
                loadingsuggestionmessages: false,
            }
        }
        case GET_KUDOS_BYID: {
            return {
                ...state,
                kudosmessage: [action.data],
                loadingmessage: false,
                success: true,
            }
        }
        case UPDATE_KUDOS_MESSAGE: {
            return {
                ...state,
                addKudos: action.data,
                success: true,
                loadingmessages: false,
                loadingsettings: false,
                loadingcorrections: false,
                loadingsuggestionmessages: false,
            }
        }
        default: {
            return state;
        }
    }
}

export default MenuReducer;
  

